<app-loader [isLoading]="isLoading"></app-loader>
@if(isUuid){
<router-outlet></router-outlet>
}@else {

<div class="header">
    <app-title [title]="title" [subtitle]="subtitle"></app-title>
    @if (myroles.can_write) {
    <div class="top">
        <div class="boton">
            <button class="b1" mat-button (click)="goToNewMission()">Añadir misión o visión</button>
        </div>
    </div>
    }
</div>

<div class="content">


    <table mat-table [dataSource]="dataSource" matSort (matSortChange)="announceSortChange($event)"
        class="mat-elevation-z8 table">

        <!-- Columna de ID -->
        <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                ID
            </th>
            <td mat-cell *matCellDef="let element">
                <span style="font-size: 16px;">{{element.id}}</span>
            </td>
        </ng-container>

        <!-- Columna de Título -->
        <ng-container matColumnDef="title">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                TÍTULO
            </th>
            <td mat-cell *matCellDef="let element">
                <span style="font-size: 16px;">{{element.title}}</span>
            </td>
        </ng-container>

        <!-- Columna de Descripción -->
        <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                DESCRIPCIÓN
            </th>
            <td mat-cell *matCellDef="let element">
                <span style="font-size: 16px;" class="description-cell"
                    [innerHTML]="sanitizeHtml(element.description?.slice(0,50) || '')">{{(element.description?.length ||
                    0) > 50 ? '...' : ''}}</span>
            </td>
        </ng-container>

        <!-- Columna de Visión -->
        <ng-container matColumnDef="is_vision">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>
                DESTACADO
            </th>
            <td mat-cell *matCellDef="let element">
                <span class="utility-button" style="font-size: 16px;">{{element.is_vision ? 'Sí' : 'No'}}</span>
            </td>
        </ng-container>

        <!-- Columna de Acciones -->
        <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef>
                ACCIONES
            </th>
            <td mat-cell *matCellDef="let element">
                @if (myroles.can_write) {
                <button mat-icon-button class="acciones" (click)="goToMission(element)"><mat-icon
                        svgIcon="edit"></mat-icon></button>
                }
                @if (myroles.can_delete) {
                <button mat-icon-button class="acciones" (click)="deleteSelected(element.id, element.title)"><mat-icon
                        svgIcon="delete"></mat-icon></button>
                }
            </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </tr>
    </table>
</div>
}